import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../components/utils/Button";
import CardLayout from "../../components/utils/CardLayout";
const BulkRecharge = () => {
  const [mdns, setMdns] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      plan: "",
      month: "",
    },
  });
  const handleKeyDown = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const value = inputValue.trim();

    if (!value) return;

    if (!/^[0-9]{10,15}$/.test(value)) {
      alert("Enter valid MDN.");
      return;
    }

    if (mdns.includes(value)) {
      alert("MDN already added.");
      return;
    }

    const updated = [...mdns, value];

    setMdns(updated);

    setValue("mdns", updated);

    clearErrors("mdns");

    setInputValue("");
  };
  const removeMDN = (number) => {
    const updated = mdns.filter((item) => item !== number);

    setMdns(updated);

    setValue("mdns", updated);
  };
  const onSubmit = (data) => {
    if (mdns.length === 0) {
      setError("mdns", {
        type: "manual",
        message: "Please add at least one MDN.",
      });

      return;
    }

    const payload = {
      plan: data.plan,

      month: data.month,

      mdns: mdns,
    };

    console.log(payload);
  };
  const handleReset = () => {
    reset();

    setMdns([]);

    setInputValue("");
  };
  return (
    <CardLayout title="Bulk Recharge" icon="ri-flashlight-line fs-5">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          {/* Plan */}

          <div className="col-md-6 mb-2">
            <label className="form-label fw-semibold">
              Plan <span className="text-danger">*</span>
            </label>

            <select
              className="form-control"
              {...register("plan", {
                required: "Please select plan",
              })}
            >
              <option value="">Select Plan</option>
              <option value="25">$25 Unlimited</option>
              <option value="35">$35 Unlimited</option>
              <option value="45">$45 Unlimited</option>
            </select>

            {errors.plan && (
              <small className="text-danger">{errors.plan.message}</small>
            )}
          </div>

          {/* Month */}

          <div className="col-md-6 mb-2">
            <label className="form-label fw-semibold">
              Month <span className="text-danger">*</span>
            </label>

            <select
              className="form-control"
              {...register("month", {
                required: "Please select month",
              })}
            >
              <option value="">Select Month</option>
              <option value="1">1 Month</option>
              <option value="2">2 Months</option>
              <option value="3">3 Months</option>
            </select>

            {errors.month && (
              <small className="text-danger">{errors.month.message}</small>
            )}
          </div>

          {/* MDN */}

          <div className="col-md-12 mb-3">
            <label className="form-label fw-semibold">
             MSISDN
              <span className="text-danger">*</span>
            </label>

            <div
              className="form-control d-flex flex-wrap align-items-center"
              style={{
                minHeight: "70px",
                cursor: "text",
              }}
            >
              {mdns.map((item) => (
                <span
                  key={item}
                  className="badge rounded-pill me-2 mb-2 px-3 py-2"
                  style={{
                    background: "#8E0E9D",
                    color: "#fff",
                    fontSize: "13px",
                  }}
                >
                  {item}

                  <i
                    className="ri-close-line ms-2"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => removeMDN(item)}
                  ></i>
                </span>
              ))}

              <input
                type="text"
                className="border-0 flex-grow-1"
                style={{
                  outline: "none",
                  minWidth: "180px",
                }}
                placeholder="Type MDN and press Enter"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>

            {errors.mdns && (
              <small className="text-danger">{errors.mdns.message}</small>
            )}

            <small className="text-muted">
              Press Enter after every mobile number.
            </small>
          </div>

          {/* Buttons */}

          <div className="col-12 mt-3 d-flex gap-3">
            <Button
              title="Recharge"
              buttonType="submit"
              variant="primary"
              icon={<i className="ri-flashlight-line me-2"></i>}
              // style={{
              //   minWidth: "180px",
              // }}
            />

            <Button
              title="Reset"
              buttonType="button"
              variant="secondary"
              onClick={handleReset}
              icon={<i className="ri-refresh-line me-2"></i>}
              // style={{
              //   minWidth: "150px",
              // }}
            />
          </div>
        </div>
      </form>
    </CardLayout>
  );
};
export default BulkRecharge;
